if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.upsell = document.querySelector("upsell-modal");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            return response;
          })
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const currency = document
                .querySelector("body")
                .getAttribute("data-currency");
              if (this.upsell) {
                const self = this;
                this.handleUpsellModal(response, self);
                let cartjson = await fetch("/cart.json")
                  .then((data) => data.json())
                  .catch((err) => {
                    console.log("error fetching cart");
                  });
                window.cartObj = cartjson;
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Check if upsell item is already in cart
      checkItemInCart(upselleditem) {
        return window.cartObj.items.some(
          (item) => item.product_id === parseInt(upselleditem)
        );
      }

      // Handle upsell modal logic
      handleUpsellModal(response, self) {
        console.log(self);
        const upsell = self.closest("[data-upsell]");
        if (!upsell) {
          self.cart.open();
          return;
        }
        const {
          upselleditem,
          idtoignore,
          itemtoremove,
          upsellimage,
          selectedprice,
          upsellcallout,
          upsellproduct,
        } = self.closest("[data-upsell]").dataset;
        console.log(self);
        console.log(
          upselleditem,
          idtoignore,
          itemtoremove,
          upsellimage,
          selectedprice,
          upsellcallout
        );
        console.log(self.upsell)
        if (self.upsell.querySelector("[name='id']").tagName == "SELECT") {
          const selectElement = self.upsell.querySelector("[name='id']");
          let existingOption = Array.from(selectElement.options).find(
            (option) => option.value === upselleditem
          );

          if (existingOption) {
            existingOption.selected = true;
          } else {
            const newOption = document.createElement("option");
            newOption.value = upselleditem;
            newOption.text = upselleditem;
            newOption.selected = true;
            selectElement.add(newOption);
          }
        } else {
          self.upsell.querySelector("[name='id']").value = upselleditem;
        }

        const dontopencart = true;
        const itemAlreadyInCart = this.checkItemInCart(upsellproduct);

        if (itemAlreadyInCart) {
          self.upsell.hide();
          self.cart.renderContents(response, false);
          return;
        }

        self.cart.renderContents(response, dontopencart);

        const addingIDToIgnoreUpsellFor = idtoignore
          .split(",")
          .map((id) => parseInt(id.trim()))
          .includes(response.product_id);
        const idToIgnoreExistInCart = window.cartObj.items.some((item) =>
          idtoignore
            .split(",")
            .map((id) => parseInt(id.trim()))
            .includes(item.product_id)
        );
        const addingFromUpsellModal =
          self.getAttribute("data-section-id") === "upsell-modal";
        if (
          addingFromUpsellModal ||
          addingIDToIgnoreUpsellFor ||
          idToIgnoreExistInCart
        ) {
          console.log("hide");
          self.upsell.hide();
          const itemToRemoveIds = itemtoremove
            .split(",")
            .map((id) => id.trim());
          const removeItemButtons = itemToRemoveIds
            .map((id) =>
              document.querySelector(`[data-itemidcartremove='${id}']`)
            )
            .filter((button) => button !== null);

          if (idToIgnoreExistInCart) {
            self.cart.open();
          } else if (removeItemButtons.length > 0) {
            console.log(removeItemButtons);
            removeItemButtons.forEach((button) => button.click());
          } else {
            self.cart.open();
          }
        } else {
          self.upsell.setAttribute("data-upsell", true);
          self.upsell.setAttribute("data-upselleditem", upselleditem);
          self.upsell.setAttribute("data-idtoignore", idtoignore);
          self.upsell.setAttribute("data-itemtoremove", itemtoremove);
          self.upsell.querySelector(".upsell-modal__image-container img").src =
            upsellimage;
          self.upsell.querySelector(
            ".upsell-modal__text p"
          ).innerHTML = `${upsellcallout} <strong>${selectedprice}</strong>`;
          self.upsell.show();
        }
      }
    }
  );
}
